import { atomWithStorage } from 'jotai/utils';

// ユーザーが使用するマイクのデバイスIDを状態として保存する。
export const selectedMicrophoneDeviceIdAtom = atomWithStorage<string | undefined>(
  'SELECTED_MICROPHONE_DEVICE_ID',
  undefined
);
